module.exports = __webpack_public_path__ + "client/styles/fonts/SourceSansPro-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/SourceSansPro-Light.ttf
// module id = 1482
// module chunks = 0